import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'

export const PremiumPageContentHeading: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Root>
      <Title>
        {t('premium.purchased.title-long')}
        <span>{t('premium.purchased.sub-title')}</span>
      </Title>
    </Root>
  )
}

const Root = styled.div`
  background: var(--background-3);
  height: 64px;

  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: space-between;

  padding-inline: 14px;
`

const Title = styled.div`
  color: var(--text-12);

  display: grid;

  font-size: 14px;
  font-weight: 600;
  gap: 2px;

  > span {
    color: var(--text-8);
    font-size: 12px;
    font-weight: 500;
  }
`
